(ns quuppa.qsm.signin.subs
  (:require [re-frame.core :refer [reg-sub]]))

;; TODO: Maybe a wrong place for app global subscriptions.

(reg-sub
  :user/session
  (fn [db [_]]
    (:session db)))

(reg-sub
  :user/user
  :<- [:user/session]
  (fn [session [_]]
    (:user session)))

(reg-sub
  :user/privileges
  :<- [:user/session]
  (fn [session _]
    (-> session :user :privileges set)))

(reg-sub :user/has-privilege
  :<- [:user/privileges]
  (fn [privileges [_ privilege]]
    (contains? privileges privilege)))
